import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=47c01ac4"
import script from "./thankyou.vue?vue&type=script&lang=ts"
export * from "./thankyou.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports